export default __webpack_public_path__ + "static/media/ic-chat.b5bd3ee4.svg";